<template>
  <div class="page">
    <div class="pageL">
      <div class="pageLT">
        <!-- 日历组件 -->
        <div id="petCalendar">
          <el-calendar v-model="calendarValue">
            <template slot="dateCell" slot-scope="{ date, data }">
              <div class="dateView">
                <div
                  :class="data.isSelected ? 'is-selected' : ''"
                  @click="handelSecectClick(date)"
                  class="dateSpan"
                >
                  {{ data.day.split("-").slice(2).join("-") }}
                </div>
                <div v-for="(item, index) in errArr" :key="index">
                  <template v-if="data.day == item.date">
                    <div
                      class="circle1"
                      v-if="item.status == 1 && item.dayTaskStatus == 1"
                    ></div>
                    <div
                      class="circle3"
                      v-if="item.status == 1 && item.dayTaskStatus == 0"
                    ></div>
                    <div class="circle2" v-if="item.status == 0"></div>
                    <div
                      v-if="item.status == -1 || item.dayTaskStatus == -1"
                      class="circle4"
                    ></div>

                    <img
                      src="../../../assets/img/week.png"
                      class="weekImg"
                      v-if="item.weekTaskStatus == 1"
                    />
                    <img
                      src="../../../assets/img/month.png"
                      class="monthImg"
                      v-if="item.monthTaskStatus == 1"
                    />
                  </template>
                </div>
              </div>
            </template>
          </el-calendar>
          <div class="taskView" style="margin: 10px 0">
            <div class="week" style="margin-right: 20px">
              <img src="../../../assets/img/week.png" />
              <div>已执行周任务</div>
            </div>
            <div class="month">
              <img src="../../../assets/img/month.png" />
              <div>已执行月任务</div>
            </div>
          </div>
          <div class="taskView">
            <div class="normal">
              <div></div>
              <div>宠物正常</div>
            </div>
            <div class="noNormarl">
              <div></div>
              <div>宠物异常</div>
            </div>
            <div class="day">
              <div></div>
              <div>日任务未完成</div>
            </div>
          </div>
        </div>
      </div>
      <div class="pageLB">
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ background: '#EDF3F9' }"
          class="deathTable"
        >
          <el-table-column prop="taskName" label="任务名称"> </el-table-column>
          <el-table-column label="任务次数">
            <template slot-scope="scope">
              <span v-if="scope.row.taskPlanWay == '1'"
                >每日{{ scope.row.times }}次</span
              >
              <span v-if="scope.row.taskPlanWay == '2'"
                >每周{{ scope.row.times }}次</span
              >
              <span v-if="scope.row.taskPlanWay == '3'"
                >每月{{ scope.row.times }}次</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.remark"
                placement="top"
              >
                <span>{{ scope.row.remark }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="totalTimes" label="完成次数">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pageR">
      <div class="tabView">
        <div class="tabViewL">
          <div :class="tab == 0 ? 'tab' : 'tab1'" @click="handelPlanClick(0)">
            日任务
          </div>
          <div :class="tab == 1 ? 'tab' : 'tab1'" @click="handelPlanClick(1)">
            周任务
          </div>
          <div :class="tab == 2 ? 'tab' : 'tab1'" @click="handelPlanClick(2)">
            月任务
          </div>
        </div>
        <el-button
          type="warning"
          plain
          size="small"
          style="width: 80px; height: 33px; margin-top: 8px; margin-right: 8px"
          @click="
            drawer = true;
            btnType = 0;
          "
          v-if="options.length != 0"
          >执行任务
        </el-button>
      </div>
      <!-- 任务内容 -->
      <div class="taskView">
        <div class="taskTab">
          <div
            v-for="(item, index) in tasklist"
            :key="index"
            :class="taskTab == index ? 'taskItemS' : 'taskItem'"
            @click="handelTaskTabClick(index)"
          >
            <span>{{ item.taskName }} </span>
            <span>{{ item.details.length }}/{{ item.times }}</span>
          </div>
        </div>
        <div class="taskTab">
          <div
            v-for="(item, index) in timeList"
            :key="index"
            :class="timeTab == index ? 'taskItemS' : 'taskItem'"
            style="width: 114px"
            @click="timeTab = index"
          >
            <span>{{ item.time }} </span>
            <span>{{ item.petStatus == "1" ? "正常" : "异常" }}</span>
          </div>
        </div>
        <div class="taskMsg" v-if="timeList != 0">
          <div class="taskCom">
            <div>内容:</div>
            <div>{{ timeList[timeTab].content }}</div>
          </div>
          <div class="taskCom">
            <div>图片:</div>
            <el-image
              style="width: 56px; height: 56px; margin-right: 12px"
              :src="item"
              :preview-src-list="timeList[timeTab].imgs"
              v-for="(item, index) in timeList[timeTab].imgs"
              :key="index"
            >
            </el-image>
          </div>
          <div class="taskBtn" style="display: flex">
            <div class="taskCom" style="width: 90%">
              <div>备注:</div>
              <div>{{ timeList[timeTab].remark }}</div>
            </div>
            <div class="imgS">
              <img
                src="../../../assets/img/ht4.png"
                @click="handelUploadClick"
              />
              <img
                src="../../../assets/img/ht3.png"
                @click="handelDeleteClick"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 执行任务 -->
    <el-drawer
      title="执行任务"
      size="30%"
      :visible.sync="drawer"
      custom-class="drawersend"
      direction="rtl"
    >
      <div class="sx">
        <div class="sxMsg">
          <div class="line"></div>
          <div class="comWrap">
            <div class="draDate">
              <div class="draName">任务：</div>
              <el-select
                v-model="taskPlanId"
                placeholder="请选择"
                size="small"
                style="width: 118px"
                v-if="btnType == 0"
              >
                <el-option
                  v-for="item in options"
                  :key="item.taskPlanId"
                  :label="item.taskPlanName"
                  :value="item.taskPlanId"
                >
                </el-option>
              </el-select>
              <div v-if="btnType == 1">{{ taskName }}</div>
            </div>
            <div class="draDate">
              <div class="draName">状态：</div>
              <el-radio-group v-model="petStatus" size="small">
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="0">异常</el-radio>
              </el-radio-group>
            </div>
            <div class="draRemark" style="margin-bottom: 20px">
              <div class="draName">内容：</div>
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                v-model="content"
                resize="none"
                style="flex: 1"
                size="small"
              >
              </el-input>
            </div>
            <div class="draCom">
              <div class="draName">图片：</div>
              <div class="imgView">
                <div
                  v-for="(item, index) in detailImgList"
                  :key="index"
                  class="imgItem"
                >
                  <img
                    alt=""
                    :src="item"
                    v-if="detailImgList.length > 0"
                    style="border-radius: 6px"
                  />
                  <i
                    class="el-icon-error closeBtn"
                    v-if="detailImgList.length > 0"
                    @click="handleDeleteImgClick(index)"
                  ></i>
                </div>
                <i
                  class="el-icon-plus avatar-uploader-icon"
                  style="border: 1px dashed #d9d9d9; border-radius: 6px"
                  @click="handleUploadDetailClick"
                  v-if="detailImgList.length < 9"
                ></i>
                <input
                  type="file"
                  ref="fileDetail"
                  style="width: 0; height: 0"
                  @change="changeDetailFile"
                />
              </div>
            </div>
            <div class="draRemark">
              <div class="draName">备注：</div>
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                v-model="remark"
                resize="none"
                style="flex: 1"
                size="small"
              >
              </el-input>
            </div>
          </div>
        </div>
        <div class="sxBtn">
          <div @click="canelClick">取消</div>
          <div @click="handelCertainClick" v-if="btnType == 0">确定</div>
          <div @click="handelUpdateClick" v-if="btnType == 1">更新</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  petCalendar,
  taskSummary,
  taskInfo,
  categoryTask,
  addTask,
  deleteTask,
  updateTask,
} from "@/api/purchaseApi.js";
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    category: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      calendarValue: new Date(),
      errArr: [], //错误
      tableData: [], //表格
      tab: 0,
      drawer: false,
      deathTime: "", //死亡日期
      detailImgList: [], //图片
      remark: "",
      options: [], //任务列表
      content: "", //内容
      petStatus: 1, //状态
      taskPlanId: "", //任务id
      taskTab: 0, //任务tab
      tasklist: [], //任务列表
      taskDetail: null, //任务详情
      timeList: [], //时间列表
      timeTab: 0, //时间tab
      btnType: 0, //0是执行任务  1是编辑任务
      taskName: "", //任务名称
    };
  },
  created() {
    this.$nextTick(() => {
      // 点击前一个月
      let prevBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(1)"
      );
      prevBtn.addEventListener("click", () => {
        console.log(this.calendarValue);
        this.getMonthData();
        this.getTaskInfo();
        this.getCategoryTask();
      });

      //点击下一个月
      let nextBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(3)"
      );
      nextBtn.addEventListener("click", () => {
        console.log(this.calendarValue);
        this.getMonthData();
        this.getTaskInfo();
        this.getCategoryTask();
      });

      //点击今天
      let todayBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(2)"
      );
      todayBtn.addEventListener("click", () => {
        console.log(this.calendarValue);
        this.getMonthData();
        this.getTaskInfo();
        this.getCategoryTask();
      });
    });
  },
  mounted() {
    this.getMonthData();
    this.getTaskSummary();
    this.getTaskInfo();
    this.getCategoryTask();
  },
  methods: {
    //弹框更新按钮
    handelUpdateClick() {
      if (this.content == "") {
        this.$message({
          type: "error",
          message: "请填写内容",
        });
        return;
      }
      if (this.detailImgList.length == 0) {
        this.$message({
          type: "error",
          message: "请添加图片",
        });
        return;
      }
      if (this.remark == "") {
        this.$message({
          type: "error",
          message: "请填写备注",
        });
        return;
      }
      let params = {
        content: this.content,
        petStatus: this.petStatus + "",
        remark: this.remark,
        detailId: this.timeList[this.timeTab].detailId,
      };
      let str = "";
      for (let i = 0; i < this.detailImgList.length; i++) {
        str = str + this.detailImgList[i] + ",";
      }
      params.avatarPic = str;
      updateTask(params).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "更新成功",
          });
          this.drawer = true;
          this.taskTab = 0;
          this.timeTab = 0;
          this.canelClick();
          this.getTaskInfo();
        }
      });
    },
    //更新任务
    handelUploadClick() {
      console.log(this.timeList[this.timeTab]);
      let msg = this.timeList[this.timeTab];
      this.drawer = true;
      this.btnType = 1;
      this.content = msg.content;
      this.remark = msg.remark;
      this.detailImgList = msg.imgs;
      this.petStatus = Number(msg.petStatus);
      this.taskName = msg.taskName;
    },
    //删除任务
    handelDeleteClick() {
      console.log(this.timeList[this.timeTab]);
      this.$confirm("是否删除该任务？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            detailId: this.timeList[this.timeTab].detailId,
          };
          deleteTask(params).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "已删除",
              });
              this.taskTab = 0;
              this.timeTab = 0;
              this.getTaskInfo();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //点击任务tab
    handelTaskTabClick(index) {
      console.log(this.tasklist, index);
      this.taskTab = index;
      this.timeTab = 0;
      this.timeList = this.tasklist[index].details;
    },
    //点击任务
    handelPlanClick(type) {
      this.taskTab = 0;
      this.timeTab = 0;
      if (type == 0) {
        this.tab = 0;
        this.tasklist = this.taskDetail.dayPlans;
        if (this.tasklist.length != 0) {
          this.timeList = this.tasklist[this.timeTab].details;
        } else {
          this.timeList = [];
        }
      } else if (type == 1) {
        this.tab = 1;
        this.tasklist = this.taskDetail.weekPlans;
        if (this.tasklist.length != 0) {
          this.timeList = this.tasklist[this.timeTab].details;
        } else {
          this.timeList = [];
        }
      } else if (type == 2) {
        this.tab = 2;
        this.tasklist = this.taskDetail.monthPlans;
        if (this.tasklist.length != 0) {
          this.timeList = this.tasklist[this.timeTab].details;
        } else {
          this.timeList = [];
        }
      }
    },
    //任务列表
    getCategoryTask() {
      let time = this.formatDate(this.calendarValue);
      time = new Date(time).getTime() / 1000;
      let params = {
        categoryId: this.category,
        plantime: time,
      };
      categoryTask(params).then((res) => {
        if (res.code == 0) {
          console.log("任务列表", res);
          this.options = res.data;
        }
      });
    },
    //取消弹框
    canelClick() {
      this.taskPlanId = "";
      this.petStatus = 1;
      this.content = "";
      this.detailImgList = [];
      this.remark = "";
      this.drawer = false;
      this.getTaskInfo();
    },
    //弹框确认
    handelCertainClick() {
      let time = this.formatDate(this.calendarValue);
      time = new Date(time).getTime() / 1000;
      if (this.taskPlanId == "") {
        this.$message({
          type: "error",
          message: "请选择任务",
        });
        return;
      }
      if (this.content == "") {
        this.$message({
          type: "error",
          message: "请填写内容",
        });
        return;
      }
      if (this.detailImgList.length == 0) {
        this.$message({
          type: "error",
          message: "请添加图片",
        });
        return;
      }
      if (this.remark == "") {
        this.$message({
          type: "error",
          message: "请填写备注",
        });
        return;
      }
      let params = {
        petId: this.id,
        content: this.content,
        petStatus: this.petStatus + "",
        remark: this.remark,
        source: 1,
        taskPlanId: this.taskPlanId,
        executeTime: time,
      };
      let str = "";
      for (let i = 0; i < this.detailImgList.length; i++) {
        str = str + this.detailImgList[i] + ",";
      }
      params.avatarPic = str;
      console.log(params);
      addTask(params).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "执行成功",
          });
          this.drawer = true;
          this.taskTab = 0;
          this.timeTab = 0;
          this.canelClick();
          this.getTaskInfo();
        }
      });
    },
    formatDate(date) {
      let now = date;
      // console.log(now)
      let year = now.getFullYear();
      let month =
        now.getMonth() + 1 < 10
          ? "0" + (now.getMonth() + 1)
          : now.getMonth() + 1;
      let day = now.getDate() < 10 ? "0" + now.getDate() : now.getDate();
      return `${year}-${month}-${day}`;
    },
    //获取任务内容
    getTaskInfo() {
      let time = this.formatDate(this.calendarValue);
      time = new Date(time).getTime() / 1000;
      let params = {
        time: time,
        petId: this.id,
      };
      taskInfo(params).then((res) => {
        if (res.code == 0) {
          console.log("任务详情", res);
          this.taskDetail = res.data;
          if (this.taskTab == 0) {
            this.tasklist = res.data.dayPlans;
          } else if (this.taskTab == 1) {
            this.tasklist = res.data.weekPlans;
          } else {
            this.tasklist = res.data.monthPlans;
          }
          if (this.tasklist.length != 0) {
            this.timeList = this.tasklist[this.timeTab].details;
          } else {
            this.timeList = [];
          }
        }
      });
    },
    //汇总
    getTaskSummary() {
      let params = {
        petId: this.id,
      };
      taskSummary(params).then((res) => {
        if (res.code == 0) {
          console.log("汇总", res);
          this.tableData = res.data;
        }
      });
    },
    //获取当前月
    getMonthData() {
      // console.log(this.calendarValue)
      let now = new Date(this.calendarValue);
      console.log(now);
      let year = now.getFullYear();
      let month =
        now.getMonth() + 1 < 10
          ? "0" + (now.getMonth() + 1)
          : now.getMonth() + 1;
      let temp = new Date(year, month, 0);
      let days = temp.getDate();
      let startDateStr = `${year}-${month}-01 00:00:00`;
      let endDateStr = `${year}-${month}-${days} 23:59:59`;
      // console.log(year,month,days,startDateStr,endDateStr)
      let startDate =
        new Date(startDateStr.replace(/-/g, "/")).getTime() / 1000;
      let endDate = new Date(endDateStr.replace(/-/g, "/")).getTime() / 1000;
      // console.log(startDate, endDate)
      let pamars = {
        startTime: startDate,
        endTime: endDate,
        petId: this.id,
      };
      petCalendar(pamars).then((res) => {
        console.log("日历", res);
        if (res.code == 0) {
          this.errArr = res.data;
        }
      });
    },
    //选择日期
    handelSecectClick(date) {
      this.calendarValue = date;
      console.log(date);
      this.getTaskInfo();
      this.getCategoryTask();
    },
    handleUploadDetailClick() {
      this.$refs.fileDetail.click();
    },
    //上传图片
    changeDetailFile(e) {
      var index = e.target.files[0].name.lastIndexOf(".");
      var ext1 = e.target.files[0].name.substr(index + 1);
      var formData = new FormData();
      var ext = ext1.toLowerCase();
      if (ext === "png" || ext === "jpg" || ext === "jpeg") {
        formData.append("img", e.target.files[0]);
        this.$util.uploadImg_dir(formData, { dir: "petImg" }).then((data) => {
          if (data.timestamp) {
            this.detailImgList.push(data.url);
          }
        });
      } else {
        this.$message({
          message: "只能上传jpg,jpeg,png格式的文件",
          type: "error",
        });
        return;
      }
      // this.$refs.file.value = null
    },
    //删除对应图片
    handleDeleteImgClick(index) {
      this.detailImgList.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  min-height: 734px;
  margin-top: 12px;
  font-size: 14px;
  display: flex;

  .pageL {
    width: 326px;
    display: flex;
    flex-direction: column;
    margin-right: 12px;

    .pageLT {
      height: 369px;
      background: #fff;
      margin-bottom: 12px;
      border-radius: 4px;

      .dateSpan {
        width: 100%;
        line-height: 35px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .dateView {
        width: 100%;
        height: 100%;
        position: relative;

        .circle1 {
          width: 4px;
          height: 4px;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 4px;
          background: #00db1e;
          border-radius: 50%;
          margin: 0 auto;
        }

        .circle2 {
          width: 4px;
          height: 4px;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 4px;
          background: #ff3400;
          border-radius: 50%;
          margin: 0 auto;
        }

        .circle3 {
          width: 4px;
          height: 4px;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 4px;
          background: #ffd100;
          border-radius: 50%;
          margin: 0 auto;
        }
        .circle4 {
          width: 0px;
          height: 0px;
        }

        .weekImg {
          width: 5px;
          height: 5px;
          position: absolute;
          left: 0;
          top: 0;
        }

        .monthImg {
          width: 5px;
          height: 5px;
          position: absolute;
          right: 0;
          top: 0;
        }
      }

      .taskView {
        display: flex;
        align-items: center;
        padding: 0 20px;

        .week,
        .month {
          display: flex;
          align-items: center;
        }

        img {
          width: 10px;
          height: 10px;
          margin-right: 2px;
        }

        .normal,
        .noNormarl,
        .day {
          display: flex;
          align-items: center;
          margin-right: 10px;
        }

        .normal div:nth-of-type(1) {
          width: 10px;
          height: 10px;
          border-radius: 100%;
          background: #00db1e;
          margin-right: 2px;
        }

        .noNormarl div:nth-of-type(1) {
          width: 10px;
          height: 10px;
          border-radius: 100%;
          background: #ff3400;
          margin-right: 2px;
        }

        .day div:nth-of-type(1) {
          width: 10px;
          height: 10px;
          border-radius: 100%;
          background: #ffd100;
          margin-right: 2px;
        }
      }
    }

    .pageLB {
      height: 354px;
      background: #fff;
      overflow-y: scroll;
    }

    .pageLB::-webkit-scrollbar {
      display: none;
    }
  }

  .pageR {
    flex: 1;
    height: 734px;
    background: #fff;

    .tabView {
      display: flex;
      justify-content: space-between;
      height: 44px;
      border-bottom: solid 1px #f2f2f2;

      .tabViewL {
        display: flex;
        margin-left: 20px;

        .tab {
          width: 58px;
          line-height: 42px;
          border-bottom: solid 2px #f5882a;
          margin-right: 50px;
          text-align: center;
        }

        .tab1 {
          width: 58px;
          line-height: 42px;
          border-bottom: solid 2px #fff;
          margin-right: 50px;
          text-align: center;
        }
      }
    }
    .taskView {
      padding: 0 16px;
      .taskTab {
        display: flex;
        margin: 12px 0;
        font-size: 12px;
        .taskItem {
          width: 89px;
          height: 33px;
          box-sizing: border-box;
          border: solid 1px #d5e2ff;
          background: #f7f9ff;
          text-align: center;
          border-radius: 4px;
          line-height: 33px;
          margin-right: 12px;
        }
        .taskItemS {
          width: 89px;
          height: 33px;
          box-sizing: border-box;
          border: solid 1px #f5882a;
          background: #fff;
          color: #f5882a;
          text-align: center;
          border-radius: 4px;
          line-height: 33px;
          margin-right: 12px;
        }
      }
      .taskMsg {
        margin-top: 12px;
        .taskCom {
          display: flex;
          margin-bottom: 12px;
        }
        .taskBtn {
          display: flex;
          .imgS {
            display: flex;
            align-items: center;
            img:nth-of-type(1) {
              width: 12px;
              height: 12px;
              margin-right: 10px;
              margin-left: 20px;
            }
            img:nth-of-type(2) {
              width: 14px;
              height: 14px;
            }
          }
        }
      }
    }
  }

  .sx {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .comWrap {
      padding: 20px;
      font-size: 12px;
      color: #666;
      line-height: 20px;

      .draDate {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
      }

      .draRemark {
        display: flex;
        margin-top: 20px;
      }

      .draCom {
        display: flex;

        .avatar-uploader .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .avatar-uploader .el-upload:hover {
          border-color: #409eff;
        }

        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 56px;
          height: 56px;
          line-height: 56px;
          text-align: center;
        }

        .avatar {
          width: 56px;
          height: 56px;
          display: block;
          object-fit: cover;
        }
      }
    }

    .imgView {
      flex: 1;

      .imgItem {
        position: relative;
        width: 56px;
        height: 56px;
        margin-right: 20px;
        margin-bottom: 20px;
        float: left;

        img {
          width: 100%;
          height: 100%;
        }

        .closeBtn {
          width: 20px;
          height: 20px;
          display: block;
          color: red;
          position: absolute;
          top: -10px;
          right: -10px;
          font-size: 20px;
          z-index: 5;
        }
      }
    }

    .sxBtn {
      height: 40px;
      display: flex;
      cursor: pointer;
      font-size: 14px;
      color: #fff;
      line-height: 40px;
      text-align: center;

      div:nth-of-type(1) {
        flex: 1;
        background: #e1e9fb;
        color: #467eff;
      }

      div:nth-of-type(2) {
        flex: 1;
        background: #f5882a;
      }
    }
  }
}
</style>
